import React from "react";
import DetailPurchaseOrder from "../../components/screen/purchaseOrder/DetailPurchaseOrder";
import HOC from "../../components/HOC";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import BreadcrumbPurchaseOrder from "../../components/screen/purchaseOrder/BreadcrumbPurchaseOrder";
import { ThemeProvider } from "@emotion/react";
import { theme } from "../../components/constants/muiTheme";

const DetailPurchaseOrderPage = ({ isWarehouse }) => {
  return (
    <div className="">
      <PageTemplate
        header={
          (isWarehouse ? "Central Warehouse " : "") +
          "Purchase Order Manual Detail"
        }
        breadcrumb={
          <BreadcrumbPurchaseOrder
            isWarehouse={isWarehouse ? isWarehouse : false}
          />
        }
        mainComponent={
          <ThemeProvider theme={theme}>
            <DetailPurchaseOrder
              isWarehouse={isWarehouse ? isWarehouse : false}
            />
          </ThemeProvider>
        }
        pageRole={isWarehouse ? 29 : 9}
        noPadding={true}
      />
    </div>
  );
};

export default HOC(DetailPurchaseOrderPage);
